<template>
    <div class="h-full border-r overflow-y-scroll">

        <sub-menu
            :links="links"
            header="Court of Protection"
        ></sub-menu>

    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubMenu from '@/components/menu/SubMenu.vue'
import menus from '@/utils/menus'

export default defineComponent({
    name: 'CourtSidebar',
    components: {
        SubMenu
    },
    setup() {
        const { courtSidebarLinks } = menus();

        return {
            links: courtSidebarLinks,
        }
    }  
})
</script>